if ( typeof debounce !== 'function' ) {
  window.debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
window.KEYCODES = {
  TAB: 9,
  ESC: 27,
  DOWN: 40,
  RIGHT: 39,
  UP: 38,
  LEFT: 37,
  RETURN: 13
};
window.KT_PREFIX = 'kt-';

window.KROWN = window.KROWN || {};
window.KROWN.previouslyFocused = null;
window.KROWN.functions = (() => {

  /* ---------------- IMAGE HELPERS ---------------- */

  const setImagesize = (img) => {
    let size = 0;
    if (img.offsetWidth / img.dataset.ratio < img.offsetHeight) {
      size = Math.ceil(img.offsetHeight * parseFloat(img.dataset.ratio));
    } else {
      size = Math.ceil(img.offsetWidth);
    }
    if ( size > 0 ) {
      img.setAttribute('sizes', `${size}px`);
    }
  };

  const resizeObserver = ('ResizeObserver' in window)
    ? new ResizeObserver(entries => {
        for (const entry of entries) setImagesize(entry.target);
      })
    : null;
    
  const handleImageLoad = img => {
    setImagesize(img);
    resizeObserver.observe(img);
  };

  /* ---------------- SCROLL PROGRESS CORE ---------------- */

  const progressElements = new Set();

  let ticking = false;
  let needsHeightSync = false;

  const updateScrollProgress = () => {
    
    if (needsHeightSync) {
      parallaxHeightPairs.forEach(({ target, ref }) => {
        target.style.height = `${ref.offsetHeight}px`;
      });
      needsHeightSync = false;
    }

    const viewportHeight = window.innerHeight;
  
    progressElements.forEach(({ el, callback, mode }) => {
      const rect = el.getBoundingClientRect();
      let progress = 0;
  
      if ( mode === 'enter' ) {
        // 0% when section top is at viewport bottom
        // 100% when section top is at viewport top
        // exception when the section is at the bottom of the page
        const vh = innerHeight;
        const max = document.documentElement.scrollHeight - vh;
        const top = rect.top + scrollY;
        const start = top - vh;
        progress = ((scrollY - start) * 100) / (Math.min(top, max) - start);
      } else if ( mode === 'cover' ) {
        // 0% when section is fully visible at top
        // 100% when section has fully scrolled past (bottom <= 0)
        const start = 0;
        const end = -(rect.height - viewportHeight);
        const scrolled = Math.min(Math.max(rect.top, end), start);
        progress = ((start - scrolled) * 100) / (start - end);
      } else {
        // default: 0% when section enters viewport,
        // 100% when fully scrolled through
        progress = ((viewportHeight - rect.top) * 100) / (rect.height + viewportHeight);
      }
  
      progress = Math.min(Math.max(progress, 0), 100);
      callback(progress, el);
    });
  
    ticking = false;
  };
  
  const onScrollOrResize = (e) => {
    if (e.type === 'resize') needsHeightSync = true;
    if (!ticking) {
      requestAnimationFrame(updateScrollProgress);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });

  const observeScrollProgress = (el, callback, mode = 'full') => {
    const item = { el, callback, mode };
    progressElements.add(item);
    requestAnimationFrame(updateScrollProgress);
    return () => progressElements.delete(item);
  };

  /* ---------------- PARALLAX HANDLER ---------------- */

  const parallaxHeightPairs = [];
  
  const handleParallax = id => {
    const container = document.getElementById(id);
    if (!container) return;
  
    const start = parseFloat(container.dataset.jsParallaxStart) || 0;
    const end = parseFloat(container.dataset.jsParallaxEnd) || 0;
    const unit = container.dataset.jsParallaxUnit || 'px';
    const property = container.dataset.jsParallaxProperty || 'transform'; 
    const mode = container.dataset.jsParallaxMode || 'full';
    const targets = container.querySelectorAll('[data-js-parallax]');

    let scrollRef = container;

    targets.forEach(t => {
      const ref = t.closest('[data-js-parallax-height-reference]')
        || container.querySelector('[data-js-parallax-height-reference]');
      if (ref) {
        t.style.height = `${ref.offsetHeight}px`;
        parallaxHeightPairs.push({ target: t, ref });
        if (ref.hasAttribute('data-js-parallax-scroll-reference')) {
          scrollRef = ref;
        }
      }
    });
  
    observeScrollProgress(scrollRef, (progress) => {
      const value = start + (end - start) * (progress / 100);
  
      targets.forEach(t => {
        if (property === 'transform') {
          t.style.transform = `translateY(${value}${unit})`;
        } else if (property === 'backgroundSize') {
          t.style.backgroundSize = `${value}${unit} 100%`;
        } else {
          t.style[property] = `${value}${unit}`;
        }
      });
    }, mode);
  };

  /* ---------------- EVENT LISTENERS ---------------- */

  const eventDispatcher = (eventType, detail) => {
    document.dispatchEvent(new CustomEvent(eventType, {
      bubbles: true,
      detail: detail
    }));
  };

  const updateCart = (openDrawer = true) => {
    window.refreshCart(openDrawer);
  };
  const closeCartDrawer = () => {
    document.querySelector('[data-js-site-cart-sidebar]').hide();
  };
  const openCartDrawer = () => {
    document.querySelector('[data-js-site-cart-sidebar]').show();
  };
  
  return { handleImageLoad, setImagesize, resizeObserver, observeScrollProgress, handleParallax, eventDispatcher, updateCart, closeCartDrawer, openCartDrawer };

})();

document.addEventListener('krown:cart:error', (e) => {
  if ( document.body.classList.contains('template-cart') ) {
    window.scrollTo({
      top: document.querySelector('#AjaxCartForm .kt-alert') ? Math.max(0, document.querySelector('#AjaxCartForm .kt-alert').offsetTop - 100) : 0,
      behavior: 'smooth'
    });
  } else {
    document.querySelector('#site-cart-sidebar .kt-sidebar__content')?.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
});
document.addEventListener('click', function(e) {

  // Sepet çekmecesi
  const cartSidebar = document.querySelector('[data-js-site-cart-sidebar]');
  if (cartSidebar && cartSidebar.classList.contains('kt-sidebar--opened')) {
    if (!cartSidebar.contains(e.target)) {
      cartSidebar.hide();
    }
  }

  // Arama paneli
  const searchSidebar = document.getElementById('site-search-sidebar');
  if (searchSidebar && searchSidebar.classList.contains('kt-sidebar--opened')) {
    if (!searchSidebar.contains(e.target)) {
      searchSidebar.hide();
    }
  }

});